import _classCallCheck from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/inherits";

var plugin = require('jaxcore-plugin');

var log = plugin.createLogger('Spin Service');
var spinStore = plugin.createStore('Spin Store');
import Client from '../Client';
import SpinBuffer from './buffer';
var spinIds = {};
var _instance = 0;

var Spin =
/*#__PURE__*/
function (_Client) {
  _inherits(Spin, _Client);

  function Spin(device, transport) {
    var _this;

    _classCallCheck(this, Spin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Spin).call(this));
    _this.transport = transport;
    var instance = _instance++;
    _this.log = plugin.createLogger('Spin ' + instance);
    var ip = device.ip;
    var id = device.id;
    spinIds[id] = _assertThisInitialized(_this);
    _this.id = id;
    var now = new Date();

    _this.setStore(spinStore);

    _this.setDefaults(device, {
      id: id,
      instance: instance,
      connected: false,
      spinPosition: 0,
      spinDirection: 1,
      spinPreviousTime: now,
      spinTime: now,
      knobPushed: false,
      knobPushTime: now,
      knobReleaseTime: now,
      knobPushDuration: 0,
      knobHold: false,
      buttonPushed: false,
      buttonPushTime: now,
      buttonReleaseTime: now,
      buttonPushDuration: 0,
      buttonHold: false,
      batteryVoltage: 0,
      batteryPercent: 0,
      isCharging: false,
      isCharged: false,
      sleeping: false,
      inactivityTime: 0
    });

    _this.createSettings({
      brightness: 16,
      knobHoldThreshold: 2000,
      buttonHoldThreshold: 2000,
      sleepEnabled: true,
      sleepTimer: 0
    });

    return _this;
  }

  return Spin;
}(Client);

Spin.store = spinStore;
Spin.spinIds = spinIds;
Spin.Buffer = SpinBuffer;

Spin.prototype.setDefaults = function (config, defaults) {
  this.setState(config);
  var d = {};

  for (var i in defaults) {
    if (!(i in config)) {
      d[i] = defaults[i];
    }
  }

  this.setState(d);
};

Spin.prototype.createSettings = function (settings) {
  this.settingDefaults = {};
  this.settingNames = [];

  for (var i in settings) {
    this.settingNames.push(i);
    this.settingDefaults[i] = settings[i];
    this.state[i] = settings[i];
  }
};

Spin.prototype.changeSettings = function (settings) {
  log('changing settings', settings);
  var changes = {};
  var hasChanges = false;

  for (var name in settings) {
    if (name in this.settingDefaults) {
      var value = settings[name];
      var d = {};
      d[name] = settings[name];
      var c = this.setState(d);

      if (c) {
        this.log('changed setting:', name + ' = ' + value, '(default ' + this.settingDefaults[name] + ')');
        hasChanges = true;
        changes[name] = value;
      }
    }
  }

  if (hasChanges) {
    this.log('settings-changed', changes);
    this.emit('settings-changed', changes);
  }
};

Spin.prototype._createBuffer = function () {
  if (!this._buffer) this._buffer = new Spin.Buffer(this);
};

Spin.prototype.buffer = function () {
  this._createBuffer();

  return this._buffer.spin.apply(this._buffer, Array.prototype.slice.call(arguments));
};

Spin.prototype.bufferDelay = function () {
  this._createBuffer();

  return this._buffer.delay.apply(this._buffer, Array.prototype.slice.call(arguments));
};

Spin.prototype.bufferReset = function () {
  this._createBuffer();

  return this._buffer.reset.apply(this._buffer, Array.prototype.slice.call(arguments));
};

Spin.prototype.cancelHoldEvents = function () {
  clearTimeout(this._knobHoldTimer);
  clearTimeout(this._buttonHoldTimer);
};

Spin.prototype.isConnected = function () {
  return this.state.connected;
};

Spin.prototype._connected = function () {
  this.resetDefaults();
  this.setState({
    connected: true,
    sleeping: false
  });
  this.emit('connect', this);
};

Spin.prototype.connect = function () {
  Spin.transport.connect(this);
};

Spin.prototype._removeEvents = function () {
  Spin.transport.remove(this);
};

Spin.prototype.disconnect = function () {
  this.setState({
    connected: false
  });
  this.resetDefaults();
  this.emit('disconnect', this);
};

Spin.prototype.resetDefaults = function () {
  this.setState({
    spinPosition: 0,
    knobPushed: false,
    knobReleased: true,
    buttonPushed: false,
    buttonReleased: true
  });
};

Spin.prototype.sendCommand = function () {
  var args = Array.prototype.slice.call(arguments);
  this.transport.sendCommand(this, args);
};

Spin.prototype.orbit = function (direction, speed, color1, color2) {
  console.log('client orbit(', direction, speed, color1, color2);
  this.sendCommand(this.id, 'ORBIT', direction, speed, color1, color2);
};

Spin.prototype.flash = function (color) {
  this.sendCommand(this.id, 'FLASH', color);
};

Spin.prototype.quickFlash = function (color, repeat) {
  if (!repeat) repeat = 1;
  this.sendCommand(this.id, 'QUICKFLASH', color.join(',') + ',' + repeat);
};

Spin.prototype.lightsOn = function (color) {
  this.sendCommand(this.id, 'LIGHTSON', color);
};

Spin.prototype.lightsOff = function () {
  this.sendCommand(this.id, 'LIGHTSOFF');
};

Spin.prototype.setBrightness = function (brightness) {
  this.sendCommand(this.id, 'BRIGHTNESS', brightness);
};

Spin.prototype.rotate = function (direction, color1, color2) {
  this.log('rotate', direction);
  this.sendCommand(this.id, 'ROTATE', direction, color1, color2);
};

Spin.prototype.scale = function (percent, color1, color2, color3) {
  this.sendCommand(this.id, 'SCALAR', percent, color1, color2, color3);
};

Spin.prototype.setKnobHoldThreshold = function (th) {
  this.changeSettings({
    knobHoldThreshold: th
  });
};

Spin.prototype.setButtonHoldThreshold = function (th) {
  this.changeSettings({
    buttonHoldThreshold: th
  });
};

Spin.prototype.destroy = function () {
  this.disconnect();
  this.log('destroying');

  this._removeEvents();

  delete this.state;
};

Spin.debug = function (q) {
  plugin.logger.quiet(!q);
};

Spin.create = function (device, transport) {
  if (device.id in spinIds) {
    log('device exists', device);
    spinIds[device.id].destroy();
    delete spinIds[device.id];
    var spin = new Spin(device, transport);
    return spinIds[device.id];
  } else {
    log('creating new device', device, transport);
    return new Spin(device, transport);
  }
};

export default Spin;